import React from 'react'
import styled from 'styled-components'

const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	cursor: pointer;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.visible {
		opacity: 1;
	}
`

const BlurLayer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
`

const LightboxImage = styled.img`
	position: relative;
	max-width: 90%;
	max-height: 85vh;
	object-fit: contain;
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
	transform: scale(0.96);
	transition: transform 0.3s ease;

	.visible & {
		transform: scale(1);
	}
`

interface ImageLightboxProps {
	src: string
	overlayRef: React.RefObject<HTMLDivElement>
	onClose: () => void
}

const ImageLightbox = ({ src, overlayRef, onClose }: ImageLightboxProps) => {
	return (
		<Overlay ref={overlayRef} onClick={onClose}>
			<BlurLayer />
			<LightboxImage src={src} alt='' onClick={(e) => e.stopPropagation()} />
		</Overlay>
	)
}

export default ImageLightbox
